/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Plant_ChangeInputs */

const en_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grow Change`)
};

const ar_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمِّى التغيير`)
};

const de_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachsende Veränderung`)
};

const es_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultiva el crecimiento`)
};

const fr_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultiver le changement`)
};

const it_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coltiva il cambiamento`)
};

const ja_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変化を育てる`)
};

const ko_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`변화의 씨앗 심기`)
};

const pt_br_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultivar a mudança`)
};

const ru_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать изменения`)
};

const th_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกการเปลี่ยนแปลง`)
};

const tr_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Değişimi Büyüt`)
};

const zh_cn_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`种出改变`)
};

const zh_tw_btn_plant_change = /** @type {(inputs: Btn_Plant_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種出改變`)
};

/**
* | output |
* | --- |
* | "Grow Change" |
*
* @param {Btn_Plant_ChangeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_plant_change = /** @type {((inputs?: Btn_Plant_ChangeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Plant_ChangeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_plant_change(inputs)
	if (locale === "ar") return ar_btn_plant_change(inputs)
	if (locale === "de") return de_btn_plant_change(inputs)
	if (locale === "es") return es_btn_plant_change(inputs)
	if (locale === "fr") return fr_btn_plant_change(inputs)
	if (locale === "it") return it_btn_plant_change(inputs)
	if (locale === "ja") return ja_btn_plant_change(inputs)
	if (locale === "ko") return ko_btn_plant_change(inputs)
	if (locale === "pt_br") return pt_br_btn_plant_change(inputs)
	if (locale === "ru") return ru_btn_plant_change(inputs)
	if (locale === "th") return th_btn_plant_change(inputs)
	if (locale === "tr") return tr_btn_plant_change(inputs)
	if (locale === "zh_cn") return zh_cn_btn_plant_change(inputs)
	return zh_tw_btn_plant_change(inputs)
});